module.exports = __webpack_public_path__ + "img/unlock.a5a66670.svg";